// query selector
export function q(selector)  {
  try {
    return document.querySelector(selector);
  }
  catch(e) {
    console.log('error:', e);
    return;
  }
}

// query selector all
export function qa(selector)  {
  return Array.from(document.querySelectorAll(selector));
}

// avoid monkey patching
export function u(element) {
  if (!element) return
  element.q = function(selector) {
    return this.querySelector(selector)
  };
  element.qa = function(selector) {
    return this.querySelectorAll(selector)
  };
  return element;
}

// event helpers
function eventHandler(event, handler) {
  return this.addEventListener(event, handler);
}

function eventUnHandler(event, handler) {
  return this.removeEventListener(event, handler);
}

Element.prototype.on = eventHandler;
Element.prototype.off = eventUnHandler;

Document.prototype.on = eventHandler;
Document.prototype.off = eventUnHandler;

window.on = eventHandler;
window.off = eventUnHandler;
